import { render, staticRenderFns } from "./BalanceTab.vue?vue&type=template&id=a73ede6c&"
import script from "./BalanceTab.vue?vue&type=script&lang=js&"
export * from "./BalanceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports